<template>
  <BaseScreen v-bind="screen">
    <button
      slot="title"
      class="screen__logo"
      @click="onLogoClick"
    >
      <BaseIcon name="logo" is-pied />
    </button>
    <BaseMenu
      :items="menuItems"
    />
  </BaseScreen>
</template>

<script>
import screenMixin from '@/mixins/screen';
import BaseIcon from '@/components/BaseIcon.vue';
import BaseMenu from '@/components/BaseMenu.vue';

const SECRET_ACTION_CLICK_COUNT = 5;

export default {
  name: 'HomeScreen',
  mixins: [screenMixin],
  components: {
    BaseIcon,
    BaseMenu,
  },
  data() {
    return {
      clickCount: 0,
    };
  },
  staticData: () => ({
    clickTimeout: null,
  }),
  computed: {
    menuItems() {
      return [
        {
          icon: {
            name: 'tickets',
            isPied: true,
          },
          text: this.$t('actions.buyTicket'),
          action: () => this.$router.push(this.$router.options.paths.events),
          isSquare: true,
        },
        {
          icon: {
            name: 'feedback',
          },
          text: this.$t('actions.addFeedback'),
          action: () => this.$router.push(this.$router.options.paths.feedback),
        },
        {
          icon: {
            name: 'entertainment',
          },
          text: this.$t('actions.showEntertainment'),
          action: () => this.$router.push(this.$router.options.paths.entertainment),
        },
        {
          icon: {
            name: 'photo',
          },
          text: this.$t('actions.takeMyPhoto'),
          action: () => this.$router.push(this.$router.options.paths.takePhoto),
        },
      ];
    },
  },
  beforeDestroy() {
    this.clearClickTimeout();
  },
  methods: {
    onLogoClick() {
      this.clickCount += 1;
      if (this.clickCount >= SECRET_ACTION_CLICK_COUNT) {
        this.$router.push(this.$router.options.paths.admin);
      }
      if (!this.clickTimeout) {
        this.clickTimeout = window.setTimeout(() => {
          this.clearClickCount();
          this.clearClickTimeout();
        }, 2000);
      }
    },
    clearClickCount() {
      this.clickCount = 0;
    },
    clearClickTimeout() {
      window.clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
    },
  },
};
</script>
